<script setup>
import { Link } from '@inertiajs/vue3'
import UserAvatar from '@/Components/Users/UserAvatar.vue'

defineProps({
  message: {
    type: Object,
    required: true,
  },
  inConversation: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <div
    class="relative mt-5 flex w-full items-start gap-4"
    :class="[
      message.is_sender && inConversation ? 'flex-row-reverse justify-start' : 'justify-start',
    ]"
  >
    <Link
      class="shrink-0"
      :class="[message.is_sender && inConversation ? 'hidden' : '']"
      rel="nofollow"
      :href="route('members.show', message.sender.id)"
    >
      <UserAvatar :user="message.sender" small />
    </Link>
    <div class="flex flex-col gap-1">
      <div class="flex items-center gap-1">
        <Link
          :href="route('members.show', message.sender.id)"
          class="flex items-center gap-2 text-xs font-bold text-gray-700"
          :class="[message.is_sender && inConversation ? 'flex-row-reverse' : '']"
        >
          {{ message.is_sender ? 'You' : message.sender.name }}
        </Link>
      </div>
      <div
        class="relative max-w-sm rounded-lg bg-white p-2 text-sm antialiased shadow md:max-w-md lg:max-w-lg"
      >
        <div class="prose-sm whitespace-break-spaces sm:prose">
          <p>{{ message.body }}</p>
        </div>
      </div>
      <span class="inline text-xs font-normal text-gray-500">{{ message.created_at }}</span>
    </div>
  </div>
</template>
